
export const Colors = [
  {
    title: "Duo tones",
    description: "Palette de couleur duo",
    img: "",
    link: "https://duotones.co",
    alt: "duo tone illustration",
    category: "Palettes de couleur",
    tags: ["Couleur", "Palette"],
  },
  {
    title: "Grabient - Dégradés",
    description: "Dégradés avec possibilité de copié / collé css",
    img: "",
    link: "https://www.grabient.com/",
    alt: "grabient degradé",
    category: "Palettes de couleur",
    tags: ["Degradé", "CSS"],
  },
];

export const Illustrations = [
  {
    title: "Blush illustration",
    description: "Illustrations libres de droit",
    img: "",
    link: "https://blush.design/",
    alt: "blush illustration",
    category: "Illustrations",
    tags: ["Illustration", "Personnages"],
  },
];

export const DevTools = [
  {
    title: "Carbon",
    description: "Outil de présentation d'extrait de code",
    img: "https://carbon.now.sh/static/brand/banner.png",
    link: "https://carbon.now.sh/",
    alt: "Carbon code illustration",
    category: "Code",
    tags: ["Code", "Thème", "Présentation"],
  },
  {
    title: "Svg Animation",
    description: "Permet d'animer des svgs et d'exporter le code correspondant",
    img: "",
    link: "https://maxwellito.github.io/vivus-instant/?fbclid=IwAR3PWhPrOZRh1RUqhissFET1fPilhdc-mCGwjQgSKvfmK8YpbjjrrwYnkjo",
    alt: "svg animation",
    category: "Code",
    tags: ["Code", "Animation", "CSS"],
  },
  {
    title: "Animation css",
    description: "Outil permettant de générer du css en fonction de différentes animations",
    img: "https://assets.website-files.com/5b6259c4adb83957a3028f76/5b6cccb941c616d6086bae92_Animista.JPG",
    link: "https://maxwellito.github.io/vivus-instant/?fbclid=IwAR3PWhPrOZRh1RUqhissFET1fPilhdc-mCGwjQgSKvfmK8YpbjjrrwYnkjo",
    alt: "svg animation",
    category: "Code",
    tags: ["Code", "Animation", "CSS"],
  },
];

export const SandBox = [
  {
    title: "Stackblitz",
    description:
      "Environnement de développement en ligne, Node JS, Frameworks comme Angular, React",
    category: "SandBox",
    img: "https://pbs.twimg.com/profile_images/1055142255722344448/xhqy_EUP_400x400.jpg",
    alt: "stackblitz sand box",
    link: "https://stackblitz.com/",
    tags: ["Sandbox", "JS", "Frameworks"],
  },
  {
    title: "Code Pen",
    description:
      "Bac à sable HTML, CSS, JS, nombreuses contributions",
    category: "SandBox",
    img: "https://www.hugochaume.com/wp-content/uploads/2015/08/logo-codepen.png",
    alt: "code pen sand box",
    link: "https://codepen.io/",
    tags: ["Sandbox", "CSS"],
  },
  {
    title: "JS fiddle",
    description:
      "Environnement de développement en ligne pour javascript",
    category: "SandBox",
    img: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Jsfiddle-logo.png",
    alt: "js fiddle sand box",
    link: "https://jsfiddle.net/",
    tags: ["Sandbox", "JS"],
  },
];

export const Learning = [
  {
    title: "Exercicsm",
    description:
      "Site permettant de s'entrainer à l'algorithmie sur différents languages.",
    category: "Algorithmie",
    img: "https://assets.exercism.io/social/general.png",
    alt: "exercism",
    link: "https://exercism.org",
    tags: ["Algo", "Entrainement", "Exercices"],
  },
  {
    title: "Code wars",
    description:
      "Site permettant de s'entrainer à l'algorithmie sur différents languages.",
    category: "Algorithmie",
    img: "https://www.codewars.com/packs/assets/logo.61192cf7.svg",
    alt: "code wars",
    link: "https://www.codewars.com/",
    tags: ["Algo", "Entrainement", "Tests techniques"],
  },
  {
    title: "Udemy",
    description: "Formation en ligne, domaines très variés. ",
    category: "Formation en ligne",
    img: "https://play-lh.googleusercontent.com/oDuTGEHru1KMr3QOfQfPKgIdNnlq3WWQxpBYND23r2a7RVnS1HW0t7dyON86Vn_QhtM",
    alt: "udemy",
    link: "https://www.udemy.com/",
    tags: ["Apprentissage", "Vidéo"],
  },
  {
    title: "Quizlet",
    description: "Outil d'apprentissage avec des cartes mémo",
    category: "Outil d'apprentissage",
    img: "https://crp.education/wp-content/uploads/2020/08/1024.893fa7e00da6339.png",
    alt: "Quizlet",
    link: "https://quizlet.com",
    tags: ["Apprentissage", "Mémo", "Révisions"],
  },
  {
    title: "W3 School",
    description: "Formation en ligne développement web général. Très bons cours et exemples en Javascript et SQL",
    category: "Outil d'apprentissage",
    img: "https://yt3.ggpht.com/dW6to0x5Crmeh7yi-YPLcQRqVrBtx2BSh8eoKTJbE8NbjloQ0sqlmdszIlxokJU_97-ndOt_=s900-c-k-c0x00ffffff-no-rj",
    alt: "w3 school",
    link: "https://www.w3schools.com/",
    tags: ["Apprentissage", "Tutoriels", "Exercices"],
  },
];

export const Design = [
  {
    title: "Laws of UX",
    description:
      "Collection de bonnes pratiques, les lois de l'UX",
    category: "Design",
    img: "https://lawsofux.com/info/posters_hu43be1eb0bd421b550734e4ec5241da4e_338164_1200x0_resize_q75_box.jpg",
    alt: "exercism",
    link: "https://lawsofux.com/",
    tags: ["Design", "UX/UI", "Bonnes pratiques"],
  },
  {
    title: "Humane by design",
    description:
      "Ressources permettant de créer des designs plus inclusifs et plus accessibles, centrés autour de l'humain.",
    category: "Design",
    img: "https://jonyablonski.com/work/humane-by-design/cover.jpg",
    alt: "Humane By design",
    link: "https://humanebydesign.com/",
    tags: ["Design", "UX/UI", "Inclusivité", "Accessibilité", ],
  },
];